import ButtonLogin from '@javascripts/components/button_login';

export default class PlayerContentGatingLogin {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._buttonLogin = new ButtonLogin({ tech, data });
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  contentGatingDuration(){
    if(this.data()){
      return this.data().contentGatingDuration();
    }

    return undefined;
  }

  buttonGatingLogin() {
    return this._buttonLogin;
  }

  init() {
    this.buttonGatingLogin().init();
  }

  hasContentGatingDuration(){
    return this.contentGatingDuration() != undefined && this.contentGatingDuration() !== -1;
  }
}
